import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import DownloadIcon from '@ps-design-system/icons/Download/Download24';
import PdfIcon from '@ps-design-system/icons/PDF/Pdf24';

import { formatBytes } from '../../utils/utils';

const FileAttachment = ({ title, file_size, asset_url, intl = {} }) => {
  const displaySize = useMemo(() => formatBytes(file_size, intl), [file_size, intl.locale]);

  const handleDownload = (e) => {
    e.preventDefault();
    const url = new URL(asset_url);
    window.open(url.toString(), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="Attachment FileAttachment padding-md">
      <div className="flex column space-between full-width">
        <PdfIcon className="file-icon" />
        <div>
          <div className="ellipsis text-small text-gray-900">{title}</div>
          <div className="flex space-between bottom">
            <div className="ellipsis text-xs text-gray-600">{displaySize}</div>
            <a className="download-file" href={asset_url} onClick={handleDownload} target="_blank" rel="noreferrer noopener" data-gtm-ignore data-google-analytics-ignore>
              <DownloadIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

FileAttachment.propTypes = {
  title: PropTypes.string,
  file_size: PropTypes.string,
  asset_url: PropTypes.string,
  intl: intlShape
};

exports.FileAttachment = injectIntl(FileAttachment);
